/** Never send authentication/mail-action URL credentials to analytics or attribution. */
const SECRET_KEYS = new Set([
	'token', 'code', 'assertion', 'password', 'secret', 'signature', 'authorization', 'api_key',
	'access_token', 'refresh_token', 'id_token', 'csrf'
]);
const ATTRIBUTION_KEYS = new Set([
	'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid'
]);
const PRIVATE_ROUTES = new Set(['/find/verify', '/find/unsubscribe', '/verify']);

export const isSensitiveActionUrl = (input: string | URL): boolean => {
	try {
		const url = input instanceof URL ? input : new URL(input, 'https://invalid.local');
		return PRIVATE_ROUTES.has(url.pathname) || [...url.searchParams.keys()].some((key) => SECRET_KEYS.has(key.toLowerCase()));
	} catch {
		return true;
	}
};

export const measurementUrl = (input: string | URL): string => {
	if (!input.toString().trim()) return '';
	try {
		const url = new URL(input.toString(), 'https://invalid.local');
		const params = new URLSearchParams();
		if (!isSensitiveActionUrl(url)) {
			for (const [key, value] of url.searchParams) {
				if (ATTRIBUTION_KEYS.has(key.toLowerCase())) params.append(key, value);
			}
		}
		url.search = params.toString();
		url.hash = '';
		return url.toString();
	} catch {
		return '';
	}
};
